import { format } from 'timeago.js';
import DateF from '../models/date-f';
import ordinalSuffix from '../utils/ordinal-suffix';

interface Options {
  dateOnly?: boolean;
  relativeNull?: boolean; // display as "Never" when null
  relativeDate?: boolean; // displays as relative date (number of days, etc.).
}

const FormatAPIDate = (date?: string, options?: Options) => {
  const relative = options?.relativeNull || options?.relativeDate;
  if (!date) {
    return relative ? 'Never' : null;
  }

  const dateTime = new DateF(date).DateTime;
  const dayWithSuffix = ordinalSuffix(dateTime.day);

  // handle date formatting options
  if (options) {
    if (options.dateOnly) {
      return `${dateTime.monthLong} ${dayWithSuffix}, ${dateTime.year}`;
    }

    if (options.relativeDate) {
      return format(dateTime.toJSDate());
    }
  }

  return `${dateTime.monthLong} ${dayWithSuffix} ${dateTime.year}, ${dateTime.toFormat('t')}`;
};

export default FormatAPIDate;
